import { InstituteService } from './../../../services/institute/institute.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FormsModule } from '@angular/forms';
import { ChipModule } from 'primeng/chip';
import { ButtonModule } from 'primeng/button';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { SliderModule } from 'primeng/slider';
import { InstituteDetailSeachRequest } from '../../../models/institute/instituteDetailSeachRequest';
import { CommonModule, DecimalPipe } from '@angular/common';
import { UtilityService } from '../../../services/utility/utility.service';
import { countryResponse } from '../../../models/country/countryResponse';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { StateResponse } from '../../../models/country/stateResponse';
import { uniqueMajors } from '../../../utility/data/gradpilot-major';
import { CourseLevelEnum, CourseLevelEnumDescriptions } from '../../../models/enums/courseLevelEnum';
import { Currency, getCurrencyDescription } from '../../../models/enums/UserRole';
// import { majorsData } from '../../../utility/data/majors-list';
import { InstituteCourseSearchRequest } from '../../../models/Institutedetails/filtersrequest';
import { CityResponse } from '../../../models/Institutedetails/CityResponse';

interface Sort { name: string; code: string; }
interface DropDown { name: string; value: string | null; }
interface City { name: string; value: string; }
interface FilterEntry { key: searchFilters; icon: string; }

export enum searchFilters {
  location = 'Location',
  types = 'Types',
  course = 'Course / Degree Level',
  studyMode = 'Study Mode',
  duration = 'Duration',
  majors = 'Majors',
  universityType = 'University Type',
  facilities = 'Facilities',
  activities = 'Activities',
  researchFacilities = 'Research Facilities',
  deadline = 'Deadline',
  matchYourVibe = 'Match Your Vibe',
  admissionDifficulty = 'Admission Difficulty',
  campus = 'Campus',
  finance = 'Finance',
  alumni = 'Alumni',
}

interface AppliedFilter { filterType: searchFilters; value?: any; }

@Component({
  selector: 'app-institute-serach-filter',
  standalone: true,
  imports: [
    AutoCompleteModule, InputTextModule, DecimalPipe, InputNumberModule,
    FormsModule, CommonModule, ChipModule, ButtonModule,
    DropdownModule, CheckboxModule, SliderModule
  ],
  templateUrl: './institute-serach-filter.component.html',
  styleUrls: ['./institute-serach-filter.component.scss']
})
export class InstituteSerachFilterComponent implements OnInit {
  @Output() onApplyingFilter = new EventEmitter<{
    detailRequest: InstituteDetailSeachRequest;
    courseRequest: InstituteCourseSearchRequest;
  }>();

  @Input() totalCollages: string = '0';
  @Input() activeTab: string = 'universities';
  @Input() myInstitutesOnly: boolean = false;
  @Input() allUniversitiesCount: number = 0;
  @Input() partnerUniversitiesCount: number = 0;

  searchFilters = searchFilters;
  activeFilter: searchFilters | null = null;

  filterList: FilterEntry[] = [
    { key: searchFilters.location, icon: 'pi-map-marker' },
    { key: searchFilters.types, icon: 'pi-sitemap' },
    { key: searchFilters.course, icon: 'pi-book' },
    { key: searchFilters.studyMode, icon: 'pi-desktop' },
    { key: searchFilters.duration, icon: 'pi-clock' },
    { key: searchFilters.majors, icon: 'pi-graduation-cap' },
    { key: searchFilters.universityType, icon: 'pi-building' },
    { key: searchFilters.facilities, icon: 'pi-home' },
    { key: searchFilters.finance, icon: 'pi-wallet' },
    { key: searchFilters.activities, icon: 'pi-star' },
    { key: searchFilters.researchFacilities, icon: 'pi-search' },
    { key: searchFilters.alumni, icon: 'pi-users' },
    { key: searchFilters.deadline, icon: 'pi-calendar' },
    { key: searchFilters.matchYourVibe, icon: 'pi-heart' },
  ];


  countries: countryResponse[] = [];
  provinces: StateResponse[] = [];
  cities: City[] = [];
  locationSearch: string | undefined;
  selectedCountry: string | undefined;
  selectedProvince: string | undefined;
  selectedCity: string | undefined;
  distanceFromHome = 0;
  selectedDegreeOfUrbanisation: string | undefined;

  @Input() isDAPartner: boolean = false;
  daType: 'All' | 'India' | 'Abroad' = 'All';

  selectedDegreeLevels: string[] = [];
  selectedStudyModes: string[] = [];
  selectedDurations: string[] = [];



  selectedCourseLevel: CourseLevelEnum | undefined;
  selectedExchangePrograms: string | undefined;
  confirmedCourseLabel: string | null = null;
  major_program: string | undefined;


  selectedUniversityType: string | undefined;

  selectedSports = false;
  selectedPool = false;
  selectedGym = false;

  selectedCulturalFestivals = false;
  selectedTechFests = false;
  selectedCollegeFests = false;
  selectedClubsAndSocieties = false;
  selectedTech = false;
  selectedActivityArts = false;

  
  selectedEntrepreneurship = false;
  selectedLabResearchCentres = false;
  selectedFundingForStudentProjects = false;
  selectedPublicationsPerYear = 0;

  selectedInfluentialAlumni = false;
  selectedAlumniInLeadership = false;
  selectedStartupFounders = false;

  selectedApplicationStatus: string | undefined;

  selectedChill = false;
  selectedCompetitive = false;
  selectedStartupVibe = false;
  selectedResearchVibe = false;
  selectedCreative = false;
  selectedTraditional = false;

  selectedCurrency: Currency | undefined;
  tuitionFeesRange: number[] = [0, 100000];

  selectedAdmissionDifficulty: string | undefined;
  selectedCampus: string | undefined;

  courseLevels = [
    CourseLevelEnum.BachelorsDegree,
    CourseLevelEnum.MastersDegree,
    CourseLevelEnum.DoctoralDegree,
    CourseLevelEnum.DualDegree
  ].map((level) => ({
    name: CourseLevelEnumDescriptions[level].replace(' Degree', ''),
    value: level
  }));

  currencies = Object.values(Currency)
    .filter((value) => typeof value === 'number')
    .map(value => ({
      label: getCurrencyDescription(value as Currency),
      value: value as Currency
    }));

  campus: City[] = [
    { name: 'City', value: 'City' },
    { name: 'Suburb', value: 'Suburb' },
    { name: 'Urban', value: 'Urban' },
    { name: 'Town', value: 'Town' },
    { name: 'Rural', value: 'Rural' },
    { name: 'Semi-urban', value: 'Semi-urban' },
    { name: 'Suburban', value: 'Suburban' }
  ];



  universityTypeOptions: DropDown[] = [];

  applicationStatusOptions: DropDown[] = [
    { name: 'Open', value: 'Open' },
    { name: 'Closing Soon', value: 'Closing Soon' },
    { name: 'Closed', value: 'Closed' }
  ];

  majors: DropDown[] = uniqueMajors.map(major => ({ name: major, value: major }));

  appliedFilters: AppliedFilter[] = Object.values(searchFilters).map(filterType => ({
    filterType: filterType as searchFilters
  }));

  constructor(private utilityService: UtilityService, private instituteService: InstituteService) { }

  ngOnInit(): void {
    this.loadCountries();
    this.loadUniversityTypes();
  }

  private loadUniversityTypes(): void {
    this.instituteService.getControlOfInstitution().subscribe({
      next: (response) => {
        if (response.result && response.result.length > 0) {
          this.universityTypeOptions = response.result.map(type => ({
            name: type,
            value: type
          }));
        }
      },
      error: (error) => console.warn('Error loading university types:', error)
    });
  }

  private loadCountries(): void {
    this.utilityService.getCountries().subscribe({
      next: (response) => this.countries = response.result || [],
      error: (error) => console.warn('Error loading countries:', error)
    });
  }

  get hasValidFilters(): boolean {
    return this.appliedFilters.some(filter => filter.value !== undefined && filter.value !== null);
  }

  toggleSidebarFilter(filter: searchFilters): void {
    this.activeFilter = this.activeFilter === filter ? null : filter;
  }

  // toggleAddFilter(): void {
  //   if (this.activeFilter) {
  //     this.activeFilter = null;
  //   } else {
  //     this.activeFilter = this.filterList[0]?.key ?? null;
  //   }
  // }

  removeFilter(filter: AppliedFilter): void {
    this.resetFilterValue(filter);
    this.applyAllFilters();
  }

  clearAllFilters(): void {
    this.filterList.forEach(f => {
      this.resetFilterValue({ filterType: f.key });
    });
    this.isDAPartner = false;
    this.selectedDegreeLevels = [];
    this.selectedStudyModes = [];
    this.selectedDurations = [];
    
    // Explicitly re-init array
    this.appliedFilters = [];
  }

  private resetFilterValue(filter: AppliedFilter): void {
    filter.value = undefined;

    switch (filter.filterType) {
      case searchFilters.location:
        this.selectedCountry = this.selectedProvince = this.selectedCity = undefined;
        this.distanceFromHome = 0;
        this.selectedDegreeOfUrbanisation = undefined;
        break;

      case searchFilters.course:
        this.selectedCourseLevel = undefined;
        this.selectedExchangePrograms = undefined;
        this.confirmedCourseLabel = null;
        break;

      case searchFilters.majors:
        this.major_program = undefined;
        break;

      case searchFilters.universityType:
        this.selectedUniversityType = undefined;
        break;

      case searchFilters.facilities:
        this.selectedSports = this.selectedPool = this.selectedGym = false;
        break;

      case searchFilters.activities:
        this.selectedCulturalFestivals = this.selectedTechFests = this.selectedCollegeFests = false;
        this.selectedClubsAndSocieties = this.selectedTech = this.selectedActivityArts = false;
        break;

      case searchFilters.researchFacilities:
        this.selectedEntrepreneurship = this.selectedLabResearchCentres = false;
        this.selectedFundingForStudentProjects = false;
        this.selectedPublicationsPerYear = 0;
        break;

      case searchFilters.alumni:
        this.selectedInfluentialAlumni = this.selectedAlumniInLeadership = false;
        this.selectedStartupFounders = false;
        break;

      case searchFilters.deadline:
        this.selectedApplicationStatus = undefined;
        break;

      case searchFilters.matchYourVibe:
        this.selectedChill = this.selectedCompetitive = this.selectedStartupVibe = false;
        this.selectedResearchVibe = this.selectedCreative = this.selectedTraditional = false;
        break;

      case searchFilters.finance:
        this.selectedCurrency = undefined;
        this.tuitionFeesRange = [0, 100000];
        break;

      case searchFilters.admissionDifficulty:
        this.selectedAdmissionDifficulty = undefined;
        break;

      case searchFilters.campus:
        this.selectedCampus = undefined;
        break;
    }
  }

  onCountrySelection(event: DropdownChangeEvent): void {
    this.selectedProvince = this.selectedCity = undefined;
    if (!event.value) {
      this.provinces = [];
      this.cities = [];
      return;
    }
    this.utilityService.getProvinces(event.value).subscribe({
      next: response => this.provinces = response.result || [],
      error: error => {
        console.warn(error);
        this.provinces = [];
      }
    });
  }

  onProvinceSelection(event: DropdownChangeEvent): void {
    this.selectedCity = undefined;
    if (!event.value) {
      this.cities = [];
      return;
    }
    this.utilityService.getCitiesByProvinceId(event.value).subscribe({
      next: response => {
        this.cities = (response.result || []).map((city: CityResponse) => ({
          name: city.name,
          value: city.name
        }));
      },
      error: error => {
        console.warn(error);
        this.cities = [];
      }
    });
  }

  onCurrencyChange(): void {
    this.tuitionFeesRange = [0, this.getMaxForCurrency()];
  }

  getCurrencySymbol(): string {
    const symbols: Record<number, string> = {
      [Currency.Dollar]: '$',
      [Currency.Rupee]: '₹',
      [Currency.Pound]: '£',
      [Currency.Euro]: '€'
    };
    return symbols[this.selectedCurrency as number] ?? '$';
  }

  getMaxForCurrency(): number {
    const maxValues: Record<number, number> = {
      [Currency.Dollar]: 100000,
      [Currency.Rupee]: 8000000,
      [Currency.Pound]: 80000,
      [Currency.Euro]: 90000
    };
    return maxValues[this.selectedCurrency as number] ?? 100000;
  }

  getStepForCurrency(): number {
    const steps: Record<number, number> = {
      [Currency.Dollar]: 1000,
      [Currency.Rupee]: 50000,
      [Currency.Pound]: 1000,
      [Currency.Euro]: 1000
    };
    return steps[this.selectedCurrency as number] ?? 1000;
  }

  searchInstitutes(): void {
    this.confirmedCourseLabel = this.selectedCourseLevel !== undefined
      ? CourseLevelEnumDescriptions[this.selectedCourseLevel] 
      : null;

    this.updateAppliedFilters();
    this.applyAllFilters();
  }

  private updateAppliedFilters(): void {
    this.appliedFilters.forEach(item => {
      switch (item.filterType) {
        case searchFilters.location:
          item.value = this.getLocationValue();
          break;
        case searchFilters.course:
          item.value = this.getCourseValue();
          break;
        case searchFilters.majors:
          item.value = this.major_program || undefined;
          break;
        case searchFilters.universityType:
          item.value = this.selectedUniversityType;
          break;
        case searchFilters.facilities:
          item.value = this.getFacilitiesValue();
          break;
        case searchFilters.finance:
          item.value = this.getFinanceValue();
          break;
        case searchFilters.activities:
          item.value = this.getActivitiesValue();
          break;
        case searchFilters.researchFacilities:
          item.value = this.getResearchFacilitiesValue();
          break;
        case searchFilters.alumni:
          item.value = this.getAlumniValue();
          break;
        case searchFilters.deadline:
          item.value = this.selectedApplicationStatus;
          break;
        case searchFilters.matchYourVibe:
          item.value = this.getVibeValue();
          break;
        case searchFilters.admissionDifficulty:
          item.value = this.selectedAdmissionDifficulty;
          break;
        case searchFilters.campus:
          item.value = this.selectedCampus;
          break;
      }
    });
  }

  private getLocationValue(): string | undefined {
    const parts = [this.selectedCountry, this.selectedProvince, this.selectedCity].filter(Boolean);
    return parts.length > 0 ? parts.join(', ') : undefined;
  }

  private getCourseValue(): string | undefined {
    const courseLevelLabel = this.selectedCourseLevel !== undefined ? CourseLevelEnumDescriptions[this.selectedCourseLevel] : null;
    const values = [
      courseLevelLabel,
      this.selectedExchangePrograms === 'Yes' ? 'Exchange Programs' : null
    ].filter(Boolean);
    return values.length > 0 ? values.join(', ') : undefined;
  }

  private getUniversityTypeValue(): string | undefined {
    return this.selectedUniversityType;
  }

  private getFacilitiesValue(): string | undefined {
    const facilities = [];
    if (this.selectedSports) facilities.push('Sports');
    if (this.selectedPool) facilities.push('Pool');
    if (this.selectedGym) facilities.push('Gym');
    return facilities.length > 0 ? facilities.join(', ') : undefined;
  }

  private getActivitiesValue(): string | undefined {
    const activities = [];
    if (this.selectedCulturalFestivals) activities.push('Cultural Festivals');
    if (this.selectedTechFests) activities.push('Tech Fests');
    if (this.selectedCollegeFests) activities.push('College Fests');
    if (this.selectedClubsAndSocieties) activities.push('Clubs');
    if (this.selectedTech) activities.push('Tech');
    if (this.selectedActivityArts) activities.push('Arts');
    return activities.length > 0 ? activities.join(', ') : undefined;
  }

  private getResearchFacilitiesValue(): string | undefined {
    const research = [];
    if (this.selectedEntrepreneurship) research.push('Entrepreneurship');
    if (this.selectedLabResearchCentres) research.push('Labs');
    if (this.selectedFundingForStudentProjects) research.push('Funding');
    if (this.selectedPublicationsPerYear) research.push(`Publications: ${this.selectedPublicationsPerYear}`);
    return research.length > 0 ? research.join(', ') : undefined;
  }

  private getAlumniValue(): string | undefined {
    const alumni = [];
    if (this.selectedInfluentialAlumni) alumni.push('Influential Alumni');
    if (this.selectedAlumniInLeadership) alumni.push('Leadership Roles');
    if (this.selectedStartupFounders) alumni.push('Startup Founders');
    return alumni.length > 0 ? alumni.join(', ') : undefined;
  }

  private getDeadlineValue(): string | undefined {
    return this.selectedApplicationStatus;
  }

  private getVibeValue(): string | undefined {
    const vibes = [];
    if (this.selectedChill) vibes.push('Chill');
    if (this.selectedCompetitive) vibes.push('Competitive');
    if (this.selectedStartupVibe) vibes.push('Startup');
    if (this.selectedResearchVibe) vibes.push('Research');
    if (this.selectedCreative) vibes.push('Creative');
    if (this.selectedTraditional) vibes.push('Traditional');
    return vibes.length > 0 ? vibes.join(', ') : undefined;
  }

  private getFinanceValue(): string | undefined {
    const isDefault = this.tuitionFeesRange[0] === 0 && this.tuitionFeesRange[1] === this.getMaxForCurrency();
    if (isDefault) return undefined;
    const symbol = this.getCurrencySymbol();
    return `${symbol}${this.tuitionFeesRange[0].toLocaleString()} - ${symbol}${this.tuitionFeesRange[1].toLocaleString()}`;
  }

  getFilterValue(filter: AppliedFilter): string | undefined {
    if (filter.filterType === searchFilters.location) {
      const parts = [];
      const countryName = this.countries.find(c => c.countryCode === this.selectedCountry)?.name;
      const provinceName = this.provinces.find(province => province.id === (this.selectedProvince as any))?.name;

      if (countryName) parts.push(countryName);
      if (provinceName) parts.push(provinceName);
      if (this.selectedCity) parts.push(this.selectedCity);
      if (this.distanceFromHome > 0) parts.push(`${this.distanceFromHome} km`);
      if (this.selectedDegreeOfUrbanisation) parts.push(this.selectedDegreeOfUrbanisation);
      return parts.length > 0 ? parts.join(', ') : undefined;
    }
    if (filter.filterType === searchFilters.finance) {
      const s = this.getCurrencySymbol();
      return `${s}${this.tuitionFeesRange[0].toLocaleString()} - ${s}${this.tuitionFeesRange[1].toLocaleString()}`;
    }
    return filter.value;
  }

  getActiveCourseLabel(): string | null {
    return this.confirmedCourseLabel;
  }

  private applyAllFilters(): void {
    const detailRequest = this.buildDetailRequest();
    const courseRequest = this.buildCourseRequest();

    this.onApplyingFilter.emit({
      detailRequest,
      courseRequest
    });
  }

  private buildDetailRequest(): InstituteDetailSeachRequest {
    return {
      isDAPartner: this.isDAPartner,
      locationSearch: this.locationSearch ?? null,
      degreeLevels: this.selectedDegreeLevels.length > 0 ? this.selectedDegreeLevels : null,
      studyModes: this.selectedStudyModes.length > 0 ? this.selectedStudyModes : null,
      durations: this.selectedDurations.length > 0 ? this.selectedDurations : null,

      country: this.getCountryName(),
      province: this.getProvinceName(),
      city: this.selectedCity ?? null,
      distanceFromHome: this.distanceFromHome > 0 ? this.distanceFromHome : null,
      degreeOfUrbanization: this.selectedDegreeOfUrbanisation ?? null,
      courseLevel: this.getCourseLevel() as any,
      hasStudentExchange: this.toBool(this.selectedExchangePrograms),
      majorOrProgram: this.major_program ?? null,
      controlOfInstitution: this.getUniversityTypeList(),
      facilities: this.hasFacilitiesSelected() ? this.getFacilitiesPayload() : null,
      activities: this.hasActivitiesSelected() ? this.getActivitiesPayload() : null,
      researchFacilities: this.hasResearchSelected() ? this.getResearchPayload() : null,
      alumni: this.hasAlumniSelected() ? this.getAlumniPayload() : null,
      applicationDeadline: this.selectedApplicationStatus ?? null,
      vibes: this.hasVibesSelected() ? this.getVibesPayload() : null,
      currency: this.isFinanceApplied() ? (this.selectedCurrency ?? null) : null,
      minCost: this.isFinanceApplied() ? this.tuitionFeesRange[0] : null,
      maxCost: this.isFinanceApplied() ? this.tuitionFeesRange[1] : null,
      name: null,
      cityType: this.selectedDegreeOfUrbanisation || this.selectedCampus || null,
      admissionDifficulty: this.selectedAdmissionDifficulty ?? null,
      pageNumber: 1,
      pageSize: 10,
      degreePreference: null
    };
  }

  get allActiveFilters(): { label: string, type: string, value: any }[] {
    const list: { label: string, type: string, value: any }[] = [];
    
    if (this.locationSearch) list.push({ label: this.locationSearch, type: 'locationSearch', value: this.locationSearch });
    if (this.isDAPartner) list.push({ label: 'DA partner universities', type: 'isDAPartner', value: true });
    
    this.selectedDegreeLevels.forEach(lvl => list.push({ label: lvl, type: 'degreeLevels', value: lvl }));
    this.selectedStudyModes.forEach(mode => list.push({ label: mode, type: 'studyModes', value: mode }));
    this.selectedDurations.forEach(dur => list.push({ label: dur, type: 'durations', value: dur }));
    
    if (this.selectedCourseLevel !== undefined) {
      const name = CourseLevelEnumDescriptions[this.selectedCourseLevel] || ('Level ' + this.selectedCourseLevel);
      list.push({ label: name, type: 'courseLevel', value: this.selectedCourseLevel });
    }
    
    if (this.selectedCountry) list.push({ label: this.selectedCountry, type: 'country', value: this.selectedCountry });
    if (this.selectedProvince) list.push({ label: this.selectedProvince, type: 'province', value: this.selectedProvince });
    if (this.selectedCity) list.push({ label: this.selectedCity, type: 'city', value: this.selectedCity });
    
    if (this.isFinanceApplied()) {
      list.push({ label: `Tuition ${this.getCurrencySymbol()}${this.tuitionFeesRange[0]} - ${this.tuitionFeesRange[1]}`, type: 'finance', value: this.tuitionFeesRange });
    }

    if (this.selectedUniversityType) list.push({ label: this.selectedUniversityType, type: 'universityType', value: this.selectedUniversityType });
    if (this.major_program) list.push({ label: this.major_program, type: 'major_program', value: this.major_program });
    
    return list;
  }

  removeActiveFilter(filter: { label: string, type: string, value: any }): void {
    if (filter.type === 'locationSearch') this.locationSearch = '';
    else if (filter.type === 'isDAPartner') this.isDAPartner = false;
    else if (filter.type === 'degreeLevels') this.selectedDegreeLevels = this.selectedDegreeLevels.filter(x => x !== filter.value);
    else if (filter.type === 'studyModes') this.selectedStudyModes = this.selectedStudyModes.filter(x => x !== filter.value);
    else if (filter.type === 'durations') this.selectedDurations = this.selectedDurations.filter(x => x !== filter.value);
    else if (filter.type === 'courseLevel') this.selectedCourseLevel = undefined;
    else if (filter.type === 'country') this.selectedCountry = undefined;
    else if (filter.type === 'province') this.selectedProvince = undefined;
    else if (filter.type === 'city') this.selectedCity = undefined;
    else if (filter.type === 'finance') {
      this.selectedCurrency = undefined;
      this.tuitionFeesRange = [0, 100000];
    }
    else if (filter.type === 'universityType') this.selectedUniversityType = undefined;
    else if (filter.type === 'major_program') this.major_program = undefined;

    this.searchInstitutes();
  }

  private buildCourseRequest(): InstituteCourseSearchRequest {
    return {
      isDAPartner: this.isDAPartner,
      locationSearch: this.locationSearch ?? null,
      degreeLevels: this.selectedDegreeLevels.length > 0 ? this.selectedDegreeLevels : null,
      studyModes: this.selectedStudyModes.length > 0 ? this.selectedStudyModes : null,
      durations: this.selectedDurations.length > 0 ? this.selectedDurations : null,

      country: this.getCountryName(),
      province: this.getProvinceName(),
      city: this.selectedCity ?? null,
      distanceFromHome: this.distanceFromHome > 0 ? this.distanceFromHome : null,
      degreeOfUrbanization: this.selectedDegreeOfUrbanisation ?? null,
      courseLevel: this.getCourseLevel(),
      hasStudentExchange: this.toBool(this.selectedExchangePrograms),
      majorOrProgram: this.major_program ?? null,
      controlOfInstitution: this.getUniversityTypeList(),
      facilities: this.hasFacilitiesSelected() ? this.getFacilitiesPayload() : null,
      activities: this.hasActivitiesSelected() ? this.getActivitiesPayload() : null,
      researchFacilities: this.hasResearchSelected() ? this.getResearchPayload() : null,
      alumni: this.hasAlumniSelected() ? this.getAlumniPayload() : null,
      applicationDeadline: this.selectedApplicationStatus ?? null,
      vibes: this.hasVibesSelected() ? this.getVibesPayload() : null,
      currency: this.isFinanceApplied() ? (this.selectedCurrency ?? null) : null,
      minCost: this.isFinanceApplied() ? this.tuitionFeesRange[0] : null,
      maxCost: this.isFinanceApplied() ? this.tuitionFeesRange[1] : null,
      name: null,
      cityType: this.selectedDegreeOfUrbanisation ?? this.selectedCampus ?? null,
      admissionDifficulty: this.selectedAdmissionDifficulty ?? null,
      pageNumber: 1,
      pageSize: 10,
      degreePreference: null
    };
  }

  private getCountryName(): string | null {
    return this.countries.find(country => country.countryCode === this.selectedCountry)?.name ?? null;
  }

  private getProvinceName(): string | null {
    return this.provinces.find(province => province.id === (this.selectedProvince as any))?.name ?? null;
  }

  private getUniversityTypeList(): string | null {
    return this.selectedUniversityType ?? null;
  }



  private getVibesPayload() {
    const anySelected = this.selectedChill || this.selectedCompetitive || this.selectedStartupVibe
      || this.selectedResearchVibe || this.selectedCreative || this.selectedTraditional;
    if (!anySelected) return null;
    return {
      chill: !!this.selectedChill,
      competitive: !!this.selectedCompetitive,
      startupVibe: !!this.selectedStartupVibe,
      researchVibe: !!this.selectedResearchVibe,
      creative: !!this.selectedCreative,
      traditional: !!this.selectedTraditional
    };
  }

  private hasFacilitiesSelected(): boolean {
    return this.selectedSports || this.selectedPool || this.selectedGym;
  }

  private hasActivitiesSelected(): boolean {
    return this.selectedCulturalFestivals || this.selectedTechFests || this.selectedCollegeFests
      || this.selectedClubsAndSocieties || this.selectedTech || this.selectedActivityArts;
  }

  private hasResearchSelected(): boolean {
    return this.selectedEntrepreneurship || this.selectedLabResearchCentres
      || this.selectedFundingForStudentProjects || this.selectedPublicationsPerYear > 0;
  }

  private hasAlumniSelected(): boolean {
    return this.selectedInfluentialAlumni || this.selectedAlumniInLeadership || this.selectedStartupFounders;
  }

  private hasVibesSelected(): boolean {
    return this.selectedChill || this.selectedCompetitive || this.selectedStartupVibe
      || this.selectedResearchVibe || this.selectedCreative || this.selectedTraditional;
  }

  private getCourseLevel(): number | null {
    return this.selectedCourseLevel !== undefined ? this.selectedCourseLevel : null;
  }

  private isFinanceApplied(): boolean {
    return this.appliedFilters.find(f => f.filterType === searchFilters.finance)?.value !== undefined;
  }

  private getFacilitiesPayload() {
    return {
      sportsFacilities: !!this.selectedSports,
      swimmingPool: !!this.selectedPool,
      gym: !!this.selectedGym
    };
  }

  private getActivitiesPayload() {
    return {
      culturalFestivals: !!this.selectedCulturalFestivals,
      techFests: !!this.selectedTechFests,
      collegeFests: !!this.selectedCollegeFests,
      clubsAndSocieties: !!this.selectedClubsAndSocieties,
      tech: !!this.selectedTech,
      arts: !!this.selectedActivityArts
    };
  }

  private getResearchPayload() {
    return {
      entrepreneurship: !!this.selectedEntrepreneurship,
      labAndResearchCentres: !!this.selectedLabResearchCentres,
      fundingForStudentProjects: !!this.selectedFundingForStudentProjects,
      publicationsPerYear: this.selectedPublicationsPerYear || 0
    };
  }

  private getAlumniPayload() {
    return {
      hasInfluentialAlumni: !!this.selectedInfluentialAlumni,
      hasAlumniInLeadershipRoles: !!this.selectedAlumniInLeadership,
      hasStartupFoundersFromCollege: !!this.selectedStartupFounders
    };
  }



  private toBool(val: string | undefined): boolean | null {
    if (val === 'Yes') return true;
    if (val === 'No') return false;
    return null;
  }

  togglePill(list: string[], item: string): void {
    const index = list.indexOf(item);
    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push(item);
    }
    this.searchInstitutes();
  }

  toggleDegreeLevel(level: string): void {
    this.togglePill(this.selectedDegreeLevels, level);
  }

  toggleCourseLevelValue(val: CourseLevelEnum): void {
    if (this.selectedCourseLevel === val) {
      this.selectedCourseLevel = undefined;
    } else {
      this.selectedCourseLevel = val;
    }
    this.searchInstitutes();
  }

  toggleStudyMode(mode: string): void {
    this.togglePill(this.selectedStudyModes, mode);
  }

  toggleDuration(duration: string): void {
    this.togglePill(this.selectedDurations, duration);
  }

  setDaType(type: 'All' | 'India' | 'Abroad') {
    this.daType = type;
    if (type === 'All') {
      this.isDAPartner = false;
      this.selectedCountry = undefined;
    } else if (type === 'India') {
      this.isDAPartner = true;
      const indiaCode = this.countries.find(c => c.name.toLowerCase() === 'india')?.countryCode;
      if (indiaCode) {
        this.selectedCountry = indiaCode;
      }
    } else if (type === 'Abroad') {
      this.isDAPartner = true;
      this.selectedCountry = undefined;
    }
    this.searchInstitutes();
  }
}